<template>
  <div class="filter">
    <div class="label-title">
      {{ $t('view-Search.filter-title.gender') }}
    </div>
    <div class="d-flex justify-content-between">
      <filter-option
        :title="$t('gender.male')"
        :icon="`${$publicPath}img/search-icon/gender-male.svg`"
        :active="isActive('male')"
        add-class="w-option-3"
        @click="setValue('male')"
      />
      <filter-option
        :title="$t('gender.female')"
        :active="isActive('female')"
        :icon="`${$publicPath}img/search-icon/gender-female.svg`"
        add-class="w-option-3"
        @click="setValue('female')"
      />
      <filter-option
        :title="$t('gender.other')"
        :active="isActive('other')"
        :icon="`${$publicPath}img/search-icon/gender-other.svg`"
        add-class="w-option-3"
        @click="setValue('other')"
      />
    </div>
  </div>
</template>

<script>
import FilterOption from '../FilterOption'

export default {
  components: {
    'filter-option': FilterOption
  },
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setValue (value) {
      if (this.multiple) {
        let filters = this.value || []
        const index = filters.indexOf(value)

        if (index === -1) {
          filters.push(value)
        } else {
          filters = filters.filter((item, i) => i !== index)
        }
        this.$emit('input', filters)
      } else {
        this.$emit('input', value)
      }
    },
    isActive (value) {
      if (this.multiple) {
        const index = this.value ? this.value.indexOf(value) : -1
        return index !== -1
      } else {
        return this.value === value
      }
    }
  }
}
</script>
